/* eslint-disable */
// @ts-nocheck

import type { VeloxiApp } from 'veloxi'
import { createApp } from 'veloxi'

import type { SwapyConfig, SwapyPluginApi } from './swapy'
import { SwapyPlugin } from './swapy'

let app: VeloxiApp
function installPlugin() {
  if (app) {
    app.updatePlugin<SwapyConfig, SwapyPluginApi>(SwapyPlugin)
    return app
  }
  app = createApp()
  app.addPlugin<SwapyConfig, SwapyPluginApi>(SwapyPlugin)
  app.run()
  return app
}

export { installPlugin }
